const DeeplinkEnum = Object.freeze({
  CODE_LOGIN: "code-login",
});

export default DeeplinkEnum;
